import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '@/context/StoreContext';
import { toast } from 'sonner';
import { Loader2, Lock } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useStore();
  const navigate = useNavigate();
  const [email, setEmail] = useState('admin@nicewine.com');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); toast.success('Welcome'); navigate('/admin'); }
    catch { toast.error('Invalid credentials'); }
    finally { setLoading(false); }
  };

  const field = 'w-full bg-transparent border border-nw-gold/25 rounded-[3px] px-3 h-12 text-nw-ivory placeholder:text-nw-warmgrey/50 focus:outline-none focus:border-nw-gold text-sm';
  const label = 'block text-[10px] tracking-luxe uppercase text-nw-warmgrey mb-2';

  return (
    <div className="nw-container py-24 flex items-center justify-center min-h-[70vh]">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Lock className="text-nw-gold mx-auto" size={26} strokeWidth={1} />
          <div className="font-serif text-nw-gold text-2xl tracking-[0.25em] mt-4">NICEWINE</div>
          <div className="nw-eyebrow mt-2">Back-Office</div>
        </div>
        <form onSubmit={submit} className="space-y-4 bg-nw-espresso border border-nw-gold/20 p-8">
          <div><label className={label}>Email</label><input data-testid="admin-email-input" type="email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} /></div>
          <div><label className={label}>Password</label><input data-testid="admin-password-input" type="password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          <button data-testid="admin-login-submit-button" disabled={loading} className="nw-btn-gold w-full h-12">
            {loading ? <Loader2 size={16} className="animate-spin" /> : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
